@let complete = $complete();
@let isLoading = $isLoading();

<unity-outside-container [modalHeaderSubtitle]="modalHeaderSubtitle" [modalHeaderTitle]="modalHeaderTitle">
  <div class="outside-form">
    @if (complete) {
      <kendo-stacklayout orientation="vertical" [gap]="15">
        <h5>Confirmation Email Sent</h5>
        <h6>An email with a confirmation link has been sent to:</h6>
        <div class="email-wrapper">
          <span class="email">{{ form.controls.username.value }}</span>
        </div>
        <h6>
          To confirm your account, please check your inbox and follow the instructions in the email.
          <br />
          If you don't see it immediately, wait a few minutes and check again.
          <br />
          Remember to check your spam or junk folder!
        </h6>
        <button kendoButton themeColor="primary" routerLink="/login" type="button">Back to Login</button>
      </kendo-stacklayout>
    } @else {
      <kendo-stacklayout orientation="vertical" [gap]="15">
        <form id="resetForm" [formGroup]="form" (ngSubmit)="onResetSubmit()">
          <unity-textbox-control
            displayName="Email Address"
            description="Enter the email address you signed up with."
            [showHint]="false"
            [control]="form.controls.username"
            [clearButton]="true" />
        </form>
        <button kendoButton themeColor="primary" form="resetForm" type="submit" [disabled]="form.invalid || isLoading">
          @if (!isLoading) {
            Request New Confirmation Email
          } @else {
            <kendo-loader type="infinite-spinner" size="small" themeColor="info" />
          }
        </button>
        <button kendoButton themeColor="tertiary" routerLink="/login" type="button">Back to Login</button>
      </kendo-stacklayout>
    }
  </div>
</unity-outside-container>
